module.exports = __webpack_public_path__ + "img/msb-icon.9f956e60.png";